import { List, Text } from "@mantine/core";
import { Link } from "react-router";
import { GENERATOR_EDIT_TABS } from "../../../../../components/ObjectModals/GeneratorModal/GeneratorModal.constants";
import { ObjectUrlName } from "../../../../../utils/enums";
import type { Paragraph6CreditErrorMessageDetailProps } from "../Paragraph6CreditErrorMessage";

function GeneratorsWithIncompleteVeraeusserungsformenErrors({
  paragraph6CreditErrors
}: Paragraph6CreditErrorMessageDetailProps) {
  const generatorsWithIncompleteVeraeusserungsformenErrors =
    paragraph6CreditErrors.filter(
      (error) =>
        error.generators_with_incomplete_veraeusserungsformen.length > 0
    );

  if (generatorsWithIncompleteVeraeusserungsformenErrors.length === 0) {
    return null;
  }

  return (
    <>
      {generatorsWithIncompleteVeraeusserungsformenErrors.map((error, key) => (
        <List.Item key={`generator-error-${key}`}>
          Veräußerungsformen vom {error.billing_period.start_date} bis{" "}
          {error.billing_period.end_date} für folgende Anlagen:{" "}
          {error.generators_with_incomplete_veraeusserungsformen.map(
            (g, index) => (
              <Text component="span" key={`${g.site_id}_${g.id}`}>
                {g.site_id && g.id ? (
                  <Link
                    to={`../../liegenschaften/${g.site_id}/${ObjectUrlName.Generators}/${g.id}/${GENERATOR_EDIT_TABS.TAB_EEG_ANLAGE_DATA}`}
                  >
                    {g.name}
                  </Link>
                ) : (
                  g.name
                )}
                {index <
                  error.generators_with_incomplete_veraeusserungsformen.length -
                    1 && ", "}
              </Text>
            )
          )}{" "}
        </List.Item>
      ))}
    </>
  );
}

export { GeneratorsWithIncompleteVeraeusserungsformenErrors };
